var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "div",
          { staticClass: "box" },
          [
            _c(
              "el-form",
              {
                ref: "basicForm",
                staticClass: "searchForm",
                attrs: {
                  model: _vm.basicForm,
                  "label-position": "right",
                  "label-width": "120px",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "检测窗口期", prop: "windowTime" },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.basicForm.windowTime,
                                callback: function ($$v) {
                                  _vm.$set(_vm.basicForm, "windowTime", $$v)
                                },
                                expression: "basicForm.windowTime",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "版本", prop: "versionText" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.basicForm.versionText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.basicForm, "versionText", $$v)
                                },
                                expression: "basicForm.versionText",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "产品编码", prop: "fiveBitCode" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.basicForm.fiveBitCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.basicForm, "fiveBitCode", $$v)
                                },
                                expression: "basicForm.fiveBitCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "产品中文名称",
                              prop: "fiveBitCodeName",
                            },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.basicForm.fiveBitCodeName,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.basicForm,
                                    "fiveBitCodeName",
                                    $$v
                                  )
                                },
                                expression: "basicForm.fiveBitCodeName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "工厂名称", prop: "facilityName" },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.basicForm.facilityName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.basicForm, "facilityName", $$v)
                                },
                                expression: "basicForm.facilityName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "烹饪方式", prop: "cookCodeText" },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.basicForm.cookCodeText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.basicForm, "cookCodeText", $$v)
                                },
                                expression: "basicForm.cookCodeText",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "修改备注",
                              prop: "updateReason",
                              rules: {
                                required: true,
                                message: "修改备注不能为空",
                                trigger: "blur",
                              },
                            },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "textarea",
                                rows: 1,
                                maxlength: "1000",
                                "show-word-limit": "",
                                disabled: _vm.isDisabled,
                              },
                              model: {
                                value: _vm.basicForm.updateReason,
                                callback: function ($$v) {
                                  _vm.$set(_vm.basicForm, "updateReason", $$v)
                                },
                                expression: "basicForm.updateReason",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "box" },
          [
            _c("el-row", [
              _c("div", { staticClass: "info_box_title" }, [
                _c("p", { staticClass: "line" }),
                _c("p", { staticClass: "info_title" }, [
                  _vm._v("Nutrition明细"),
                ]),
              ]),
            ]),
            _c(
              "el-row",
              [
                _c(
                  "el-form",
                  { ref: "detailForm", attrs: { model: _vm.detailForm } },
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.detailForm.currentDetailList,
                          "max-height": "425",
                          border: "",
                          stripe: "",
                        },
                      },
                      _vm._l(
                        _vm.detailForm.tableHeaderList,
                        function (item, index) {
                          return _c("el-table-column", {
                            key: index,
                            attrs: {
                              prop: item.prop,
                              label: item.label,
                              "min-width": "150",
                              "render-header": (h, obj) =>
                                _vm.renderHeader(h, obj, item),
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            prop:
                                              `currentDetailList.${scope.$index}.` +
                                              `${item.prop}`,
                                            rules: item.required
                                              ? {
                                                  required: true,
                                                  message: "请输入*",
                                                  trigger: ["blur", "change"],
                                                }
                                              : "",
                                          },
                                        },
                                        [
                                          item.prop == "windowTime" ||
                                          item.prop == "version"
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.row[item.prop])
                                                ),
                                              ])
                                            : _c("el-input", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  disabled: _vm.isDisabled,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.propInput(
                                                      scope.row,
                                                      item.prop,
                                                      $event
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: scope.row[item.prop],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      item.prop,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row[item.prop]",
                                                },
                                              }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-row",
          {
            staticStyle: { "margin-top": "10px" },
            attrs: { type: "flex", justify: "center", align: "middle" },
          },
          [
            !_vm.isDisabled
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl",
                        value: _vm.NUTR_REPORT_EDIT_DATA,
                        expression: "NUTR_REPORT_EDIT_DATA",
                      },
                    ],
                    attrs: {
                      type: "primary",
                      disabled: _vm.isSaveDisabled,
                      loading: _vm.isSaveLoading,
                    },
                    on: { click: _vm.onSave },
                  },
                  [_vm._v("保存")]
                )
              : _vm._e(),
            _c(
              "el-button",
              { attrs: { plain: "" }, on: { click: _vm.onCancel } },
              [_vm._v("取消")]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }